import {Employee} from "../domain/entities/employee.entity";
import {AbstractCommand} from "./abstract.command";
import {CommandName} from "./command-name.enum";

export class RenameEmployeeCommand extends AbstractCommand<Employee> {

    public name: CommandName = CommandName.RENAME_EMPLOYEE;

    public tags = ['entity', 'change', 'employee'];

    constructor(payload: Employee) {
        super('employee', payload.uid, payload);
    }
}